import type { ReactNode } from 'react';

export type BadgeTone =
  | 'neutral'
  | 'primary'
  | 'accent'
  | 'secondary'
  | 'warning'
  | 'danger'
  | 'success';

interface BadgeProps {
  tone?: BadgeTone;
  icon?: string;
  children: ReactNode;
  className?: string;
}

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-background-100 text-foreground-700 border-background-200',
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  warning: 'bg-amber-100 text-amber-800 border-amber-200',
  danger: 'bg-red-100 text-red-700 border-red-200',
  success: 'bg-primary-100 text-primary-800 border-primary-200',
};

export default function Badge({ tone = 'neutral', icon, children, className = '' }: BadgeProps) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium whitespace-nowrap',
        TONES[tone],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {icon && (
        <span className="w-3.5 h-3.5 flex items-center justify-center">
          <i className={`${icon} text-sm`}></i>
        </span>
      )}
      {children}
    </span>
  );
}